import { connect } from 'react-redux';

import ResetPasswordView from './ResetPasswordView.jsx';
import { changePassword, changingPasswordSucceeded } from 'src/redux/actions/users.ts';

const mapStateToProps = (state) => {
  return {
    errors: state.users.changePassword.error,
    changingPassword: state.users.changePassword.changing,
    changedPassword: state.users.changePassword.changed
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    changePassword: (oldPassword, newPassword1, newPassword2) => {
      dispatch(changePassword({oldPassword, newPassword1, newPassword2}));
    },

    resetForm: () => {
      dispatch(changingPasswordSucceeded())
    }
  }
}

const ResetPasswordPage = connect (
    mapStateToProps,
    mapDispatchToProps
)(ResetPasswordView);

export default ResetPasswordPage;